import { render, staticRenderFns } from "./CU-Q2OL.vue?vue&type=template&id=6a70670c&scoped=true&lang=pug&"
import script from "./CU-Q2OL.vue?vue&type=script&lang=js&"
export * from "./CU-Q2OL.vue?vue&type=script&lang=js&"
import style0 from "./CU-Q2OL.vue?vue&type=style&index=0&id=6a70670c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70670c",
  null
  
)

export default component.exports